import createDOMPurify from 'dompurify'
function InnerHtml({rawHTML}) {
    const sanitizer = createDOMPurify.sanitize;
    return (
        <div dangerouslySetInnerHTML={{__html: sanitizer(rawHTML)}} />
    );
}

export default InnerHtml;